/* eslint-disable import/prefer-default-export */ export function redirectTo(path) { window.location.href = path; }
